import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import { NewMainWidgetTextField } from 'views/rebranded-module/common/components/UI/NewMainWidget';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import React from 'react';

export const StyledNewMainWidgetTextField = styled(NewMainWidgetTextField)(
  ({ theme }) => ({
    '& .MuiInputBase-input.MuiFilledInput-input': {
     padding: theme.spacing(3.6 , 1, 1.75, 7),
    },
    '& .MuiInputAdornment-root': {
      display: 'none',
    },
    '& .MuiFormLabel-root':{
    position: 'absolute',
    fontSize: theme.typography.pxToRem(10),
    textTransform: 'uppercase',
    lineHeight:  theme.typography.pxToRem(10),
    color: theme.palette.text.secondary,
    left: theme.spacing(7),
    top: theme.spacing(2.25),
     transform: 'unset',
     transition:'unset',
    },
  }),
);

export const StyledMuiDatePicker = ({ whiteLabelWidget, ...props }) => {
  const newTheme = (theme) => {
    const baseTheme = {
      ...theme,
      components: {
        MuiPickersDay: {
          styleOverrides: {
            root: {
              fontSize: theme.typography.pxToRem(14),
              fontWeight: 400,
            },
          },
        },
        MuiDayCalendar: {
          styleOverrides: {
            weekDayLabel: {
              fontSize: theme.typography.pxToRem(14),
              fontWeight: 700,
            },
          },
        },
        MuiPickersToolbar: {
          styleOverrides: {
            root: {
              display: 'none',
            },
          },
        },
      },
    };

    if (whiteLabelWidget) {
      baseTheme.components.MuiDialog = {
        styleOverrides: {
          paper: {
            height: 'auto',
            maxHeight: `calc(100% - ${theme.spacing(1)})`,
            maxWidth: 'unset',
            '& .MuiPickersSlideTransition-root': {
              minHeight: theme.spacing(28.75),
            },
            '& .MuiPickersLayout-root': {
              height: '100%',
            },
            '& .MuiPickersCalendarHeader-root': {
              marginTop: theme.spacing(1),
              marginBottom: theme.spacing(1),
            },
            '& .MuiDialogActions-root': {
              paddingTop: theme.spacing(0.5),
              paddingBottom: theme.spacing(0.5),
            },
          },
        },
      };
    }

    return createTheme(baseTheme);
  };

  return (
    <ThemeProvider theme={newTheme}>
      {whiteLabelWidget ? (
        <MobileDatePicker {...props} />
      ) : (
        <MuiDatePicker {...props} />
      )}
    </ThemeProvider>
  );
};